export default __webpack_public_path__ + "static/media/sun.27a681c8.svg";